import { render, staticRenderFns } from "./common-juese.vue?vue&type=template&id=ca2bc8e4&"
import script from "./common-juese.vue?vue&type=script&lang=ts&"
export * from "./common-juese.vue?vue&type=script&lang=ts&"
import style0 from "./common-juese.vue?vue&type=style&index=0&id=ca2bc8e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports